var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Hi I'm a custom text-field "),_c('v-text-field',{staticClass:"mt-3",attrs:{"rules":_vm.rules,"counter":_vm.counter,"label":_vm.title,"clearable":_vm.clearable,"readonly":_vm.readOnly,"outlined":""},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }